import React, { useState, useEffect } from "react";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

const StaticContentManagement = () => {
  const [staticContents, setStaticContents] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const defaultContent = [
      {
        _id: "1",
        contentType: "PRIVACY_POLICY",
        title: "Privacy Policy",
        description: "...",
        createdAt: "2025-06-17T10:00:00Z",
      },
      {
        _id: "2",
        contentType: "REFUND_POLICY",
        title: "Refund Policy",
        description: "...",
        createdAt: "2025-06-17T10:00:00Z",
      },
      {
        _id: "3",
        contentType: "TERMS_AND_CONDITIONS",
        title: "Terms and Conditions",
        description: "...",
        createdAt: "2025-06-17T10:00:00Z",
      },
    ];
    setStaticContents(defaultContent);
  }, []);

  const columns = [
    {
      name: "Sr No.",
      selector: (row, index) => index + 1,
      width: "80px",
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <FaEdit
          title="Edit"
          style={{ color: "#ff9800", cursor: "pointer" }}
          onClick={() =>
            navigate("/admin/edit-static-content", {
              state: { content: row, mode: "edit" },
            })
          }
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div style={{ minHeight: "100vh", padding: "20px", background: "#f5f7fa" }}>
      <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "10px" }}>
        <div style={{ display: "flex", 
            alignItems:"center",

          justifyContent: "space-between", flexWrap: "wrap" }}>
          <h4 style={{ margin: 0 }}>Static Content Management</h4>
        </div>
        </div>
        <br/>
        <div className="modifyTable" style={{borderRadius:"12px"}}>

        <DataTable
          title=""
          columns={columns}
          data={staticContents}
          highlightOnHover
          responsive
          striped
          pagination={false} // ❌ No pagination
          subHeader={false}  // ❌ No search
        />
      </div>
    </div>
  );
};

export default StaticContentManagement;
